<template>
  <div id="trails" v-if="storeTrail.trails?.length !== 0">
    <Loader
      v-if="storeLoader.load[2]"
      :loader="storeLoader.load[2]"
      loaderSize="h-28"
      spinnerSize="small"
    />

    <Accordion
      v-else
      id="trail"
      :activeIndex="storeTrail.currentTrailIndex"
      @tab-open="storeTrail.selectTrail($event.index)"
      expandIcon=""
      collapseIcon=""
      class="custom-into"
      lazy
    >
      <AccordionTab
        v-for="(trail, trailIndex) in storeTrail.trails"
        :key="trail.id"
      >
        <template #header>
          <ButtonAccordion :data="trail" :index="trailIndex" isTrail />
        </template>

        <slot />
      </AccordionTab>
    </Accordion>

    <QuizTrigger />
  </div>
</template>

<script lang="ts">
import { useLoaderStore } from "@/store/linear/loader";
import { useQuizStore } from "@/store/linear/quiz";
import { useTrailStore } from "@/store/linear/trail";
import { defineComponent, defineAsyncComponent, watch } from "vue";

const QuizTrigger = defineAsyncComponent(() => import("./quiz-trigger.vue"));
const ButtonAccordion = defineAsyncComponent(
  () => import("./button-accordion.vue")
);

export default defineComponent({
  name: "SidebarTrails",
  components: { QuizTrigger, ButtonAccordion },
  setup() {
    const storeTrail = useTrailStore;
    const storeQuiz = useQuizStore;
    const storeLoader = useLoaderStore;

    watch(
      () => storeTrail.trails,
      (val) => (storeTrail.trails = val),
      { deep: true }
    );

    return { storeTrail, storeQuiz, storeLoader };
  },
});
</script>

<style lang="scss">
.custom-into {
  .p-accordion-header .p-accordion-header-link {
    background-color: white;
    border: 0px;
  }
  .p-accordion-content {
    padding: 0;
    margin: 0;
    border: 0px;
  }
}
</style>
